import type { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@volca/ui/components/ui/stack";
import type { ApInvoice } from "@/accounts-payable/types";

export const vendorCol: ColumnDef<ApInvoice> = {
  id: "vendor",
  header: "Vendor",
  accessorFn: (row) => row.vendor_name,
  meta: { size: "200px" },
  cell: ({ row }) => (
    <Stack align="start" gap={1}>
      <span className="font-medium">{row.original.vendor_name}</span>
      {row.original.service_address && (
        <span className="text-xs text-subtle">
          {row.original.service_address}
        </span>
      )}
    </Stack>
  ),
};
